// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2Lf63","overlay":"Button_overlay__1gxXH","inverted":"Button_inverted__3iu_2"};